'use strict';

angular.module('docketbook')
.controller('groupSettingsAdminsController', function(userService, $scope, Restangular, $window, $state, $stateParams, accessControl) {
  mixpanel.track("Opened GroupSettings-Admins Desktop");

  $scope.currentUser = accessControl.currentUser();
	$scope.currentState = $state.current;
	$scope.sampleCompany = accessControl.isSampleCompany();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.groupEdit = $scope.currentOrgGroup;

  /***** DATA *****/
	userService.getMembers(null, function(users) {
		$scope.allUsers = users;
	}, function(err) {
		$scope.allUsers = [];
	});

  userService.getRoles(null, function(roles) {
		$scope.allRoles = roles;
	}, function(err) {
		$scope.allRoles = [];
	});

	$scope.formattedUsersForDisplay = function(userList) {
		return userList.map((owner) => {
			if (owner.emailAddress.indexOf("users.docketbook.io") !== -1) {
				owner.displayEmailAddress = `0${owner.emailAddress.split("@")[0].substring(3)}`;
			} else {
				owner.displayEmailAddress = owner.emailAddress;
			}
			if (accessControl.isSampleCompany()) {
				const user = owner;
				if ((user.name.first === "Chris") && (user.name.last === "Digger")) {
					owner.displayEmailAddress = "chris.digger@fakeaddress.com"
				} else if ((user.name.first === "John") && (user.name.last === "Trucks")) {
					owner.displayEmailAddress = "john.trucks@fakeaddress.com"
				} else if ((user.name.first === "Steve") && (user.name.last === "Dozer")) {
					owner.displayEmailAddress = "steve.dozer@fakeaddress.com"
				}
			}
			return owner;
		})
	}

  userService.getOrganisationGroup($scope.currentOrgGroup.id, function(groupFull) {
    $scope.groupEdit.owners = $scope.formattedUsersForDisplay(groupFull.owners);
    userService.getGroupMembers({ 'sort' : 'first', 'groupId' : $scope.groupEdit.id }, function(membersUserInfo) {
      populateOwnerStatus($scope.groupEdit, membersUserInfo);
    });
  });

  $scope.reloadGroupOwners = function(groupEdit) {
    userService.getOrganisationGroup(groupEdit.id, function(groupFull) {
      groupEdit.owners = $scope.formattedUsersForDisplay(groupFull.owners);
    }, function(err) {

    });
  }

  // Add owners to group
  $scope.addOwnersToGroup = function(groupEdit) {
    // get list of existing users for this group
    var existingOwners = [];
    for ( var i = 0; i < groupEdit.owners.length; i++ ) {
      existingOwners.push(groupEdit.owners[i].id);
    }
    $scope.selectOrgPeopleFromParent(existingOwners, function(people) {
      if ( people != null ) {
        var membersToAdd = [];
        for ( var i = 0; i < people.length; i++ ) {
          var person = {'user':people[i].id, roles: ['owner']};
          membersToAdd.push(person);
        }

        userService.assignMembersToGroup(groupEdit.id, membersToAdd, function(success) {
          $scope.reloadGroupOwners(groupEdit);
        }, function(err) {
          $scope.alertService.presentAutoAlert('addGroupOwner', err);
        });
      }
    });
  }

  // populate onDocketbook status of owners list
	var populateOwnerStatus = function(group, usersList) {
		for ( var i = 0; i < group.owners.length; i++ ) {
			for ( var j = 0; j < usersList.length; j++ ) {
				if ( group.owners[i].id == usersList[j].id ) {
					group.owners[i].onDocketbook = usersList[j].onDocketbook;
					break;
				}
			}
		}
	}

  $scope.removeOwnerFromGroup = function(owner, group) {
    swal({
      title: "Are you sure?",
      text: "Do you really want to remove " + owner.name.full + "?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function(isConfirm){
      if (isConfirm) {
        userService.removeOwnerFromGroup(group.id, owner.id, function(success) {
    			for ( var i = 0; i < group.owners.length; i++ ) {
    				if ( group.owners[i].id == owner.id ) {
    					group.owners.splice(i, 1);
    					break;
    				}
    			}
    		}, function(err) {
    			$scope.alertService.presentAutoAlert('removeGroupOwner', err);
    		});
      }
    });
  }

  // Inviting new members
	$scope.inviteNewMembers = function(group, type) {
		$("#inviteMembersModal").fadeIn(200);
		$scope.newMemberInvitesLoading = false;
		$scope.inviteMembers = {};
		if ( type ) {
			$scope.inviteMembers.type = type;
		} else {
			$scope.inviteMembers.type = 'member';
		}
		$scope.newMemberInvites = [{}];
	}

	$scope.addBlankInvitee = function() {
		$scope.newMemberInvites.push({});
	}

	$scope.removeInvitee = function(invitee) {
		$scope.newMemberInvites.splice($scope.newMemberInvites.indexOf(invitee),1);
	}

	$scope.closeInviteMembers = function() {
		$("#inviteMembersModal").fadeOut(200);
	}

	$scope.inviteMembersContinue = function() {
		$scope.newMemberInvitesLoading = true;
		var invitesArray = [];
		for ( var i = 0; i < $scope.newMemberInvites.length; i++ ) {
			var roleAdd = "";
			if ( $scope.inviteMembers.type == 'members' ) {
				roleAdd = $scope.newMemberInvites[i].role.id;
			} else if ( $scope.inviteMembers.type == 'owner' ) {
				roleAdd = 'owner';
			} else {
				roleAdd = 'monitor';
			}
			var newInvite = { 'emailAddress' : $scope.newMemberInvites[i].emailAddress.replace(/\s/g,''), 'roles' : [roleAdd], 'firstName' : $scope.newMemberInvites[i].firstName, 'lastName' : $scope.newMemberInvites[i].lastName };
			invitesArray.push(newInvite);
		}

		userService.assignMembersToGroup($scope.groupEdit.id, invitesArray, function(success) {
			if ( $scope.inviteMembers.type == 'members' ) {
				$scope.reloadGroupMembers($scope.groupEdit);
			} else if ( $scope.inviteMembers.type == 'owner' ) {
				$scope.reloadGroupOwners($scope.groupEdit);
			} else {
				$scope.reloadGroupMonitors($scope.groupEdit);
			}
			$scope.closeInviteMembers();
		}, function(err) {
			$scope.newMemberInvitesLoading = false;
			$scope.alertService.presentAutoAlert('addGroupMembers', err);
		});
	}
});



// WEBPACK FOOTER //
// ./src/controllers/groupSettings/admins.js